import React from "react";
import EmailDashboard from "../assets/img/Products/Email-Campaign-dashboard.png"
import epicXKanban from "../assets/img/Products/Epicx-Kanban.png"
import emailTemplate from "../assets/img/Email-Template-choose.png"
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { Link } from "react-router-dom";

const AIEmailProduct = () => {
  return (
    <>
    <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: "900px" }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown">AI Email Automation</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown">
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item">
              <a href="#">E-Commerce</a>
            </li>
            <li className="breadcrumb-item active text-primary">AI Email Automation</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4">
              <div className="user-selection rounded">
                <img
                  src={EmailDashboard}
                  className="img-fluid rounded"
                  alt="Email Dashboard"
                  style={{ width: "480px" }}
                />
              </div>
            </div>
            <div className="col-md-8 p-1">
              <h1>Run High-Impact Campaigns with Smart Email Automation</h1>
              <p>
                Supercharge your email marketing with our AI-based Email
                Application, designed to help businesses create, automate, and
                optimize email campaigns effortlessly. With hundreds of
                pre-built templates, AI-driven personalization, advanced
                automation, and seamless Mailgun integration, you can engage
                your audience, boost conversions, and maximize ROI.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* AI-Driven Email Personalization Start */}
      <section className="p-5" style={{backgroundColor:'#ecfff7'}}>
        <div className="container">
          <div className="row g-5">
            <div className="col-md-7 p-5">
              <h1>AI-Driven Email Personalization</h1>
              <div className="p-1">
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> Smart Subject Line Optimization – AI suggests high-performing subject lines to increase open rates.</li>
                <li><span className="icon-box"></span> Dynamic Content Customization – Tailored emails based on customer behavior and preferences.</li>
                <li><span className="icon-box"></span> Automated A/B Testing – AI optimizes email variations for better engagement.</li>
                <li><span className="icon-box"></span> Hundreds of Professionally Designed Templates – Covering promotions, newsletters, sales, and more.</li>
              </ul>
            </div></div>
            <div className="col-md-5">
              <div className="user-selection rounded">
                <img
                  src={epicXKanban}
                  className="img-fluid rounded w-100"
                  alt="About-epic-X Process"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* AI-Driven Email Personalization End */}

      {/* Ready-to-Use Email Templates Start */}
      <section className="bg-white p-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5">
              <div className="user-selection rounded">
                <img
                  src={emailTemplate}
                  className="img-fluid rounded w-100"
                  alt="Email Templates"
                />
              </div>
            </div>
            <div className="col-md-7 p-1">
              <h1>Ready-to-Use Email Templates</h1>
              <div className="p-1">
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> Hundreds of Professionally Designed Templates – Covering promotions, newsletters, sales, and more.</li>
                <li><span className="icon-box"></span> Drag-and-Drop Editor – Customize emails without coding.</li>
                <li><span className="icon-box"></span> Mobile-Optimized & Responsive – Ensures a seamless experience across all devices.</li>
                <li><span className="icon-box"></span> AI-Powered Audience Segmentation – Target users based on behavior, demographics, and engagement.</li>
              </ul>
            </div></div>
          </div>
        </div>
      </section>
      <Footer/>
      {/* Ready-to-Use Email Templates End */}
    </>
  );
};

export default AIEmailProduct;
